module.exports = new __parcel__URL__("divinecalling.a4664fe2.png").toString();